import React from 'react';
import styled, { css } from 'styled-components';
import { OnlineThemeType } from '../../themes/online';
import Logo from '../../assets/sunbit-logo-tm.svg';
import RefreshIcon from '../../assets/refresh-icon.svg';

export interface IBrandProps {
  className?: string;
  subTitle: string;
  onAppBarSubTitleClick?: () => void;
}

export interface IBrandPropsWithTheme extends IBrandProps {
  theme: OnlineThemeType;
}

const StyledBrand = ({ theme }: IBrandPropsWithTheme) => {
  return css`
    min-width: 272px;
    height: 100%;
    padding: 10px 20px;
    border-right: 1px solid ${theme.colors.brightBlue};
    display: flex;

    > .content {
      display: flex;
      gap: 10px;
      align-items: center;

      img {
        height: 59px;
        width: 144px;
      }

      > .change {
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 18px;
        cursor: pointer;
        color: ${theme.colors.primaryBright};
        margin-inline-start: auto;
        display: flex;
        gap: 7px;
        align-items: center;
        > img {
          height: 12px;
          width: 12px;
        }
      }
    }

    @media ${theme.device.max.tabletS} {
      display: none;
    }
    @media ${theme.device.max.laptopM} {
      min-width: 252px;
      > .content img {
        height: 39px;
        width: 124px;
      }
    }

    @media ${theme.device.max.laptop} {
      min-width: 214px;
    }
  `;
};

export const Brand = styled((props: IBrandProps) => {
  return (
    <div className={props.className}>
      <div className="content">
        <img src={Logo} alt="logo" />
        <div data-at="change-button" className="change" onClick={props.onAppBarSubTitleClick}>
          {props.subTitle && <img src={RefreshIcon} alt="change" />}

          <span>{props.subTitle}</span>
        </div>
      </div>
    </div>
  );
})`
  ${StyledBrand}
`;
